"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withMandatoryCategories = void 0;

var react_1 = __importDefault(require("react"));

var mobx_react_lite_1 = require("mobx-react-lite");

var lodash_1 = require("lodash");

var core_1 = require("@bodiless/core");

var fclasses_1 = require("@bodiless/fclasses");

var EditFlowContainer_1 = __importDefault(require("./EditFlowContainer"));

var StaticFlowContainer_1 = __importDefault(require("./StaticFlowContainer"));

var FlowContainerBasic = function FlowContainerBasic(props) {
  var isEdit = core_1.useEditContext().isEdit;
  return isEdit ? react_1.default.createElement(EditFlowContainer_1.default, __assign({}, props)) : react_1.default.createElement(StaticFlowContainer_1.default, __assign({}, props));
};

var FlowContainerDesignable = lodash_1.flow(mobx_react_lite_1.observer, fclasses_1.withDesign({
  Wrapper: fclasses_1.addClasses('flex flex-wrap')
}))(FlowContainerBasic);

var withMandatoryCategories = function withMandatoryCategories(categories) {
  return fclasses_1.addProps({
    mandatoryCategories: categories
  });
};

exports.withMandatoryCategories = withMandatoryCategories;
var FlowContainer = core_1.withNode(FlowContainerDesignable);
exports.default = FlowContainer;